import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { initTheme } from "./services/themeStore";
import { initWebMcp } from "./lib/webmcp";
// Brand fonts, self-hosted (each css carries latin + latin-ext for ș/ț/ă/â/î).
// Weights mirror the old Google Fonts link: Archivo 400/500/700/900,
// Archivo Black, JetBrains Mono 500/700.
import "@fontsource/archivo/400.css";
import "@fontsource/archivo/500.css";
import "@fontsource/archivo/700.css";
import "@fontsource/archivo/900.css";
import "@fontsource/archivo-black/400.css";
import "@fontsource/jetbrains-mono/500.css";
import "@fontsource/jetbrains-mono/700.css";
import "./styles/globals.css";

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("#root not found");

// Apply the persisted theme (localStorage `resto_theme`, default dark) BEFORE
// render — the index.html bootstrap already did this pre-paint; this call
// re-asserts it for anything that bypassed the shell (tests, prerender pages).
initTheme();

createRoot(rootEl).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// Expose read-only public discovery tools to in-browser AI agents (WebMCP).
// No-op in normal browsers (feature-detected), so users are unaffected.
initWebMcp();
